import { Injectable } from '@angular/core';
import { apiConfig } from 'src/app/config/api-config';
import { environment } from 'src/environments/environment';
import { ApiConfig } from '../../models/env/api-config';

import { replaceParams } from '../../utils/strings/string-utils';

@Injectable({
  providedIn: 'root'
})
export class EnvService {

  constructor() { }


  getUrlForProvider(module: string): ApiConfig {

    const api: any = environment.api;
    const consolidatedConfig = Object.assign({ module }, api[module] ?? {}, apiConfig[module] ?? {});
    const config = new ApiConfig(consolidatedConfig);
    if (config.baseUrl == null) {
      config.baseUrl = environment.baseUrl;
    }

    return config;
  }

  buildFeatureUrl(module: string, feature: string, pathVariables: any[]) {
    const url = this.getUrlForProvider(module).featureUrl(feature);
    return replaceParams(url!, pathVariables);
  }


  getMapApiKey() {
    return environment['mapApiKey'];
  }

  getCdnImageUrl() {
    return environment.cdn.images.baseUrl;
  }

  showPlaceDetailWidget() {
    return environment.placeDetailWidgetEnabled != null && environment.placeDetailWidgetEnabled;
  }
  
}
